import React from 'react';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
export default class CenterPanelView extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <span>
        <div className="ui form">
          <div>
            <label className="placeholder-label  no-bold color-placeholder mrtnull pdtnull">
              {APP.LANGUAGE.WaitingAreaGeneralInfo.NamePlaceholder}
            </label>
            <div className="mrls word-break">{' ' + this.props.waitingArea.name}</div>
          </div>
          <div className="mrtxs">
            <label className="placeholder-label  no-bold color-placeholder">
              {APP.LANGUAGE.WaitingAreaGeneralInfo.DescriptionPlaceholder}
            </label>
            <div className="mrls word-break">{' ' + this.props.waitingArea.shortDescription}</div>
          </div>
          <div className="mrtl">
            {this.props.waitingArea.networkTypeId === NetworkTypes.WaitingArea
              ? APP.LANGUAGE.WaitingAreaGeneralInfo.RegularConsultationsDescription
              : APP.LANGUAGE.WaitingAreaGeneralInfo.GroupConsultationsDescription}
            <div className="mrbm placeholder-label">
              <span>{APP.LANGUAGE.WaitingAreaGeneralInfo.ConsultationsDescriptionHint}</span>
            </div>
          </div>
        </div>

        <div className="mrbs hide-on-small-ress " />
      </span>
    );
  }
}
